import React from "react";
import RetailerPerformanceTable from "../../containers/retailerPerformance/retailerPerfDashboard/index";
import MnpActivation from "../../containers/retailerPerformance/retailerPerfDashboard/mnpActivation";
import { isEmptyObject } from "../../utils/common/index";
import ATPDashboard from "../../containers/retailerPerformance/atpDashboard/index";
import {
  triggerRetailerPerformanceAPI,
  triggerMnpActivationAPI,
  triggerAtpFseAPI,
  triggerATPOuterAPI,
  triggerATPInnerAPI,
} from "../../redux/actions/index";
import Spinner from "../../components/presentationals/Spinner";
import FormControl from "../../components/formControl";
import CustomDropdown from "../../components/presentationals/CustomDropdown";
import config from "../../utils/config";
import LoadingAutocomplete from "../../components/presentationals/LoadingAutocomplete";
import { Button } from "@material-ui/core";

const RetailerPerformanceViews = (props) => {
  const {
    data,
    hierarchy,
    handleChange,
    selectedTab,
    moduleName,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    timestampArr,
    partnerName,
    searchFields,
    setSearchFields,
    distList,
    filteredArray,
    onRunClick,
    partnerRoleType,
    loading,
  } = props;

  const rolesWithFilter = [
    "nhq",
    "region head",
    "state head",
    "jc",
    "area manager",
    "jpm",
  ];
  const isRoleWithFilter = rolesWithFilter.includes(partnerName?.toLowerCase());

  const retailerPerformanceModel = hierarchy
    ? hierarchy.filter(
        (item) => item?.moduleName?.toLowerCase() === "retailer performance"
      )[0]?.modSecMasterTxDtos
    : null;

  // For roles with filter, only show content after partner is selected and data is available
  // For other roles, show content if data exists
  const shouldShowContent = isRoleWithFilter
    ? searchFields?.partner &&
      !loading &&
      retailerPerformanceModel &&
      !isEmptyObject(data)
    : !isEmptyObject(data) && retailerPerformanceModel;

  // Always render filter and heading for roles with filter, even if data is empty
  if (isRoleWithFilter || !isEmptyObject(data)) {
    // if (retailerPerformanceModel) {
    return (
      <div className="container-fluid">
        <div className="mt-4 mb-1">
          {isRoleWithFilter ? (
            <div className="whitebox mt-2 mb-1">
              <form autoComplete="off">
                {partnerName?.toLowerCase() === "nhq" ? (
                  <FormControl
                    variant="outlined"
                    type="form"
                    styleName="formControl"
                  >
                    <CustomDropdown
                      name={"Region"}
                      data={config.region}
                      changeHandler={(value) =>
                        setSearchFields((prev) => ({
                          ...prev,
                          region: value,
                          state:
                            config?.states?.[
                              config?.regionMaps?.[value?.toUpperCase()]
                            ]?.[0],
                        }))
                      }
                      value={searchFields?.region}
                    />
                  </FormControl>
                ) : null}
                {["nhq", "region head"].includes(partnerName.toLowerCase()) ? (
                  <FormControl
                    variant="outlined"
                    type="form"
                    styleName="formControl"
                  >
                    <CustomDropdown
                      name={"State"}
                      data={
                        config?.states?.[
                          config?.regionMaps?.[
                            searchFields?.region?.toUpperCase()
                          ]
                        ]
                      }
                      changeHandler={(value) =>
                        setSearchFields((prev) => ({
                          ...prev,
                          state: value,
                        }))
                      }
                      value={searchFields?.state}
                    />
                  </FormControl>
                ) : null}
                {partnerName?.toLowerCase()?.includes("area") && (
                  <FormControl
                    variant="outlined"
                    type="form"
                    styleName="formControl"
                  >
                    <CustomDropdown
                      name="JC"
                      data={filteredArray?.["JC"]}
                      changeHandler={(value) =>
                        setSearchFields((prev) => ({
                          ...prev,
                          jc: value,
                        }))
                      }
                      value={searchFields?.jc}
                    />
                  </FormControl>
                )}

                {[
                  "nhq",
                  "region head",
                  "state head",
                  "jc",
                  "jpm",
                  "area manager",
                ].includes(partnerName.toLowerCase()) ? (
                  distList?.loading ? (
                    <FormControl
                      variant="outlined"
                      type="form"
                      styleName="formControl"
                    >
                      <LoadingAutocomplete
                        loading={distList?.loading}
                        label={
                          partnerName?.toLowerCase()?.includes("area")
                            ? "RDS/ARD/MARD"
                            : "Partner Name"
                        }
                      />
                    </FormControl>
                  ) : (
                    <FormControl
                      variant="outlined"
                      type="form"
                      styleName="formControl"
                    >
                      <CustomDropdown
                        name={
                          ["area", "jc", "jpm"].includes(
                            partnerName?.toLowerCase()
                          )
                            ? "RDS/ARD/MARD"
                            : partnerRoleType?.toLowerCase()?.includes("jpm")
                            ? "JP"
                            : "Partner Names"
                        }
                        data={distList?.data ?? []}
                        changeHandler={(value) =>
                          setSearchFields((prev) => ({
                            ...prev,
                            partner: value,
                          }))
                        }
                        value={searchFields?.partner ?? null}
                        {...(["nhq", "region head", "state head"].includes(
                          partnerName.toLowerCase()
                        ) && { labelFieldName: "partnerName" })}
                      />
                    </FormControl>
                  )
                ) : null}

                {partnerName?.toLowerCase() === "area" ? <></> : null}
                <FormControl
                  variant="outlined"
                  type="form"
                  styleName="formControl"
                >
                  <Button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      onRunClick(searchFields);
                    }}
                    variant="contained"
                    color="default"
                    disabled={!distList?.data?.length}
                  >
                    Run
                  </Button>
                </FormControl>
              </form>
            </div>
          ) : null}
        </div>

        <h2
          className="pagetitle wow fadeInUp"
          data-wow-delay=".5s"
          data-wow-duration="0.7s"
        >
          Retailer Performance
        </h2>

        <div
          className="whitebox wow fadeInUp"
          data-wow-delay=".6s"
          data-wow-duration="0.7s"
        >
          {/* { (props.sectionHeader.toLowerCase() !=='activation' && props.sectionHeader.toLowerCase() !=='recharge') ?  */}
          {isRoleWithFilter && loading ? (
            <Spinner />
          ) : shouldShowContent ? (
            <ul className="nav nav-pills tabbtndiv text-center">
              {retailerPerformanceModel?.map((section, index) => {
                return (
                  <li key={index}>
                    <a
                      data-toggle="pill"
                      onClick={() => {
                        handleChange(index, section);
                      }}
                      href={`#${index}`}
                      className={selectedTab === index ? "active" : ""}
                    >
                      {section.sectionName}
                    </a>
                  </li>
                );
              })}
            </ul>
          ) : (
            <div
              className="wow fadeInUp text-center disclaimer p-4 rounded"
              data-wow-delay=".6s"
              data-wow-duration="0.7s"
            >
              {isRoleWithFilter && (
                <ul>
                  <li>
                    Select the Partner Name from the dropdown and click RUN
                  </li>
                </ul>
              )}
            </div>
          )}
          {/* : null     
                        }  */}

          {shouldShowContent && (
            <div className="tab-content">
              <div id={`#${selectedTab}`} className="tab-pane fade in active">
                <div className="tabcontbox">
                  {retailerPerformanceModel?.map((section, index) =>
                    section.isSectionActive === "Y"
                      ? section.sectionName === "MNP"
                        ? selectedTab === index && (
                            <MnpActivation
                              key={index}
                              moduleName={moduleName}
                              section={section.sectionName}
                              filterValue={filterValue}
                              searchFields={searchFields}
                              url={
                                section?.secTilesMasterTxDtos[0]
                                  ?.tileEndPointUrl
                              }
                              headerSelectedDateFrom={headerSelectedDateFrom}
                              headerSelectedDateTo={headerSelectedDateTo}
                              triggerMnpActivationAPI={triggerMnpActivationAPI}
                              timestampArr={timestampArr}
                            />
                          )
                        : section.sectionName === "ATP Dashboard"
                        ? selectedTab === index && (
                            <ATPDashboard
                              key={index}
                              moduleName={moduleName}
                              sectionName={section?.sectionName}
                              searchFields={searchFields}
                              urlOuter={
                                section?.secTilesMasterTxDtos[0]?.tileName ===
                                "ATP Dashboard"
                                  ? section?.secTilesMasterTxDtos[1]
                                      ?.tileEndPointUrl
                                  : section?.secTilesMasterTxDtos[0]
                                      ?.tileEndPointUrl
                              }
                              urlInner={
                                section?.secTilesMasterTxDtos[0]?.tileName ===
                                "ATP Dashboard"
                                  ? section?.secTilesMasterTxDtos[0]
                                      ?.tileEndPointUrl
                                  : section?.secTilesMasterTxDtos[1]
                                      ?.tileEndPointUrl
                              }
                              headerSelectedDateFrom={headerSelectedDateFrom}
                              headerSelectedDateTo={headerSelectedDateTo}
                              triggerAtpFseAPI={triggerAtpFseAPI}
                              triggerATPOuterAPI={triggerATPOuterAPI}
                              triggerATPInnerAPI={triggerATPInnerAPI}
                              timestampArr={timestampArr}
                            />
                          )
                        : selectedTab === index && (
                            <RetailerPerformanceTable
                              key={index}
                              moduleName={moduleName}
                              section={section?.sectionName}
                              retailerPerformanceModel={section}
                              url={
                                section?.secTilesMasterTxDtos[0]
                                  ?.tileEndPointUrl
                              }
                              data-cy="retailer-performance"
                              searchFields={searchFields}
                              filterValue={filterValue}
                              headerSelectedDateFrom={headerSelectedDateFrom}
                              headerSelectedDateTo={headerSelectedDateTo}
                              triggerRetailerPerformanceAPI={
                                triggerRetailerPerformanceAPI
                              }
                              timestampArr={timestampArr}
                            />
                          )
                      : null
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
    //   } else {
    //     return (
    //       <div
    //         className="whitebox wow fadeInUp"
    //         data-wow-delay=".6s"
    //         data-wow-duration="0.7s"
    //       >
    //         Unable to fetch data
    //       </div>
    //     );
    //   }
    // } else {
    //   return <Spinner />;
  }
  // For roles with filter, show spinner when loading, otherwise show empty
  // For other roles, show spinner when loading
  return loading ? <Spinner /> : <></>;
};

export default RetailerPerformanceViews;
